import { FC, useRef } from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { useSelector } from 'react-redux';
import { RootState } from '../../../ducks/store';

import './Pane.scss';

interface IProps {
  small?: boolean;
  left?: boolean;
}

const Pane: FC<IProps> = ({ small, left, children }) => {
  const { showLeft, showRight } = useSelector((state: RootState) => {
    const { panes } = state;
    const { showLeft, showRight } = panes;
    return {
      showLeft,
      showRight,
    };
  });

  const ref = useRef(null);
  let className = 'Pane';
  if (left) {
    className += '-left';
  } else {
    className += '-right';
  }

  if (small) {
    className += '-small';
  } else {
    className += '-big';
  }

  return (
    <CSSTransition
      in={left ? showLeft : showRight}
      timeout={300}
      classNames={className}
      nodeRef={ref}
    >
      <div
        className={classNames('Pane', {
          'Pane-small': small,
          'Pane-left': left,
          'Pane-right': !left,
        })}
        ref={ref}
      >
        {children}
      </div>
    </CSSTransition>
  );
};

export default Pane;
